import {
  ELFWebsiteInsertModel,
  ELFWebsiteModel,
  ELFWebsiteUpdateModel
} from '@shared/models/ELFWebsite';
import { ApiService } from '@shared/services';
import { PaginationRequestModel } from '@shared/models/Pagination';
import { IELFWebsiteService } from '@shared/interfaces/services';

export class ELFWebsiteService extends ApiService implements IELFWebsiteService {
  constructor() {
    super('/elfWebsite/parent');
  }

  getItems(params: PaginationRequestModel) {
    const cancelToken = this.getCancelToken('getELFWebsiteItemsToken');
    return this.get('/get', { cancelToken, params });
  }

  addELFWebsite(params: ELFWebsiteInsertModel) {
    return this.post('/add', params);
  }

  updateELFWebsite(params: ELFWebsiteUpdateModel) {
    return this.put('/update', params);
  }

  deleteItems(entries: ELFWebsiteModel[]) {
    return Promise.all(entries.map((entry: ELFWebsiteModel) =>
      this.deleteById(entry.id)));
  }
}
